import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import {
  BookingChangePossibleRequest,
  BookingsFilter,
  CreateBooking,
  CreateBookingPdf,
  UpdateBookingNoteItem,
  UpdateBookingToPreliminary,
} from '../../features/bookings/bookingsSlice';
import { OwnerOwnBooking } from '../../features/bookings/OwnerOwnInterfaces';

export function fetchBookings(bookingsFilter: BookingsFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/booking/bookings/getallbookings', bookingsFilter, config)
    .then(res => res.data);
}

export function fetchBookingsMessageEvents(bookingId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { bookingId },
  };
  return axios
    .get('/booking/bookings/getbookingmessageevents', config)
    .then(res => res.data);
}
export function isChangePossible(changeData: BookingChangePossibleRequest) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/omaliittyma-api/accommodations/isaccommodationavailableignoregivenbooking',
      changeData,
      config,
    )
    .then(res => res.data);
}

export function fetchPreBookings(bookingsFilter: BookingsFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: bookingsFilter,
  };

  return axios
    .get('/booking/bookings/getprebookingsbyauthorid', config)
    .then(res => res.data);
}

export function fetchUnConfirmedBookings(bookingsFilter: BookingsFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: bookingsFilter,
  };

  return axios
    .get('/booking/bookings/getunconfirmedbookings', config)
    .then(res => res.data);
}

export function fetchUnConfirmedInterhomeBookings(
  bookingsFilter: BookingsFilter,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: bookingsFilter,
  };

  return axios
    .get('/booking/bookings/getunconfirmedinterhomebookings', config)
    .then(res => res.data);
}

export function fetchWrongBookings(bookingsFilter: BookingsFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: bookingsFilter,
  };

  return axios
    .get('/booking/bookings/getwrongbookings', config)
    .then(res => res.data);
}

export function fetchUnConfirmedTravelBookings(bookingsFilter: BookingsFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: bookingsFilter,
  };

  return axios
    .get('/booking/bookings/getunconfirmedtravelbookings', config)
    .then(res => res.data);
}
export function updateOwnerBookingsToNewOwner(accommodationId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  const payload = { accommodationId };
  return axios
    .post('/booking/bookings/updateownerbookingstonewowner', payload, config)
    .then(res => {
      return res.data;
    });
}

export function updateMaintainerBookingsToNewMaintainer(
  accommodationId: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  const payload = { accommodationId };
  return axios
    .post(
      '/booking/bookings/updateMaintainerBookingsToNewMaintainer',
      payload,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function fetchBookingContainerDetails(bookingId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { bookingId },
  };
  return axios
    .get('/booking/bookings/getbookingcontainerdetailsbybookingid', config)
    .then(res => res.data);
}

export function sendBookingConfirmationEmailToOwnerHandler(
  bookingId: string,
  ownerId: string,
  emailAddress: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { bookingId, sendToEmail: emailAddress, ownerId },
  };
  return axios
    .get('/messaging/messaging/sendbookingconfirmationemailtoowners', config)
    .then(res => res.data);
}

export function sendBookingConfirmationEmailToMaintainerHandler(
  bookingId: string,
  caretakerId: string,
  emailAddress: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { bookingId, sendToEmail: emailAddress, caretakerId },
  };
  return axios
    .get(
      '/messaging/messaging/sendbookingconfirmationemailtocaretakers',
      config,
    )
    .then(res => res.data);
}

export function sendBookingConfirmationEmailHandler(
  bookingId: string,
  emailAddress: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { bookingId, sendToEmail: emailAddress },
  };
  return axios
    .get('/messaging/messaging/sendbookingconfirmationemailtoclient', config)
    .then(res => res.data);
}

export function sendBookingCancellationMessageHandler(
  bookingId: string,
  emailAddress: string,
) {
  const endpoint = '/messaging/messaging/sendbookingcancellationemailtoclient';
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { bookingId, sendToEmail: emailAddress },
  };
  return axios.get(endpoint, config).then(res => res.data);
}

export function sendBookingPhaseMessageHandler(
  bookingId: string,
  emailAddress: string,
  phase: number,
) {
  const endpoints: Record<number, string> = {
    1: '/messaging/messaging/sendbookingconfirmationtoclientphase1',
    2: '/messaging/messaging/sendbookingconfirmationtoclientphase2',
    3: '/messaging/messaging/sendbookingconfirmationtoclientphase3',
  };

  const endpoint = endpoints[phase];

  if (!endpoint) {
    throw new Error(`Unknown message phase type: ${phase}`);
  }
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { bookingId, sendToEmail: emailAddress },
  };
  console.log(config);
  return axios.get(endpoint, config).then(res => res.data);
}

export function sendBookingBillsMessageHandler(
  bookingId: string,
  emailAddress: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { bookingId, email: emailAddress },
  };
  const endpoint = '/messaging/messaging/sendbookinginvoicesemail';
  return axios.get(endpoint, config).then(res => res.data);
}

export function fetchInvoicePdf(invoiceId: CreateBookingPdf) {
  return axios
    .post('/booking/bookings/createbookinginvoice', invoiceId, {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
      responseType: 'blob',
    })
    .then(res => {
      const blob = new Blob([res.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      // Get file name based on conditions
      let fileName = 'Loppulasku.pdf'; // default name
      if (!invoiceId.locale?.includes('fi')) {
        fileName = 'FinalInvoice.pdf';
      }
      if (invoiceId.locale?.includes('fi')) {
        if (invoiceId.advance && invoiceId.copy && !invoiceId.compensation) {
          fileName = 'Ennakkolasku_kopio.pdf';
        } else if (
          invoiceId.advance &&
          !invoiceId.copy &&
          !invoiceId.compensation
        ) {
          fileName = 'Ennakkolasku.pdf';
        } else if (
          !invoiceId.advance &&
          invoiceId.copy &&
          !invoiceId.compensation
        ) {
          fileName = 'Loppulasku_kopio.pdf';
        } else if (
          invoiceId.advance &&
          invoiceId.copy &&
          invoiceId.compensation
        ) {
          fileName = 'Hyvityslasku_Ennakkolaskusta_Kopio.pdf';
        } else if (
          invoiceId.advance &&
          !invoiceId.copy &&
          invoiceId.compensation
        ) {
          fileName = 'Hyvityslasku_Ennakkolaskusta.pdf';
        } else if (
          !invoiceId.advance &&
          invoiceId.copy &&
          invoiceId.compensation
        ) {
          fileName = 'Hyvityslasku_Loppulaskusta_Kopio.pdf';
        } else if (invoiceId.compensation) {
          fileName = 'Hyvityslasku_Loppulaskusta.pdf';
        }
      } else if (
        invoiceId.advance &&
        invoiceId.copy &&
        !invoiceId.compensation
      ) {
        fileName = 'AdvanceInvoice_Copy.pdf';
      } else if (
        invoiceId.advance &&
        !invoiceId.copy &&
        !invoiceId.compensation
      ) {
        fileName = 'AdvanceInvoice.pdf';
      } else if (
        !invoiceId.advance &&
        invoiceId.copy &&
        !invoiceId.compensation
      ) {
        fileName = 'FinalInvoice_Copy.pdf';
      } else if (
        invoiceId.advance &&
        invoiceId.copy &&
        invoiceId.compensation
      ) {
        fileName = 'CompensationInvoice_Advance_Copy.pdf';
      } else if (
        invoiceId.advance &&
        !invoiceId.copy &&
        invoiceId.compensation
      ) {
        fileName = 'CompensationInvoice_Advance.pdf';
      } else if (
        !invoiceId.advance &&
        invoiceId.copy &&
        invoiceId.compensation
      ) {
        fileName = 'CompensationInvoice_Final_Copy.pdf';
      } else if (invoiceId.compensation) {
        fileName = 'CompensationInvoice_Final.pdf';
      }

      // Create both links
      const openLink = document.createElement('a');
      openLink.href = url;
      openLink.target = '_blank';

      const downloadLink = document.createElement('a');
      downloadLink.href = url;
      downloadLink.download = fileName;

      // Create container div for buttons
      const containerDiv = document.createElement('div');
      containerDiv.style.position = 'fixed';
      containerDiv.style.top = '50%';
      containerDiv.style.left = '50%';
      containerDiv.style.maxHeight = '40vh'; // or remove if not needed
      containerDiv.style.transform = 'translate(-50%, -50%)';
      containerDiv.style.backgroundColor = 'lightgrey';
      containerDiv.style.borderRadius = '0.5rem';
      containerDiv.style.textAlign = 'center';
      containerDiv.style.padding = '2rem';
      containerDiv.style.boxShadow = '0 0.125rem 0.625rem rgba(0,0,0,0.1)';
      containerDiv.style.zIndex = '1000';
      // Create buttons
      const openButton = document.createElement('button');
      openButton.textContent = 'Avaa lasku';
      openButton.style.maxWidth = '100%';
      openButton.className = 'btn btn-outline-blue btn-sm';
      openButton.style.backgroundColor = '#fdc300';
      openButton.onclick = () => {
        openLink.click();
        document.body.removeChild(containerDiv);
      };

      const downloadButton = document.createElement('button');
      downloadButton.textContent = 'Lataa Pdf lasku';
      downloadButton.className = 'btn btn-outline-blue btn-sm';
      downloadButton.style.backgroundColor = '#fdc300';
      downloadButton.style.maxWidth = '100%';
      downloadButton.onclick = () => {
        downloadLink.click();
        document.body.removeChild(containerDiv);
      };

      // Add buttons to container
      containerDiv.appendChild(openButton);
      containerDiv.appendChild(downloadButton);
      document.body.appendChild(containerDiv);

      // Cleanup function
      const cleanup = () => {
        window.URL.revokeObjectURL(url);
        if (document.body.contains(containerDiv)) {
          document.body.removeChild(containerDiv);
        }
      };

      // Cleanup after 10 seconds if user hasn't made a choice
      setTimeout(cleanup, 30000);

      return res.data;
    });
}
export function fetchBookingVatsDetails(bookingId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { bookingId },
  };
  return axios
    .get('/booking/bookings/getbookingvatreportbybookingid', config)
    .then(res => res.data);
}

export function fetchBookingTravelVatsDetails(bookingId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { bookingId },
  };
  return axios
    .get('/booking/bookings/getbookingtravelvatreportbybookingid', config)
    .then(res => res.data);
}

export function fetchSelectableAddOns(
  accommodationId: string,
  units: number,
  adults: number,
  childs: number,
  includeNonVisible: boolean,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId, units, adults, childs, includeNonVisible },
  };
  return axios
    .get('/booking/bookings/getselectableaddons', config)
    .then(res => res.data);
}

export function addBooking(bookingData: CreateBooking) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/booking/bookings/addbooking', bookingData, config)
    .then(res => res.data);
}

export function makeOwnerOwnBooking(bookingData: OwnerOwnBooking) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/booking/bookings/makeownerownbooking', bookingData, config)
    .then(res => res.data);
}

export function cancelBookingcall(
  bookingId: string,
  reasonOfCancellation: string,
  expectedBookingType?: number,
) {
  const params: Record<string, string | number> = {
    bookingId,
    reasonOfCancellation,
  };
  if (expectedBookingType !== undefined) {
    params.expectedBookingType = expectedBookingType;
  }

  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params,
  };

  return axios
    .delete('/booking/bookings/cancelbooking', config)
    .then(res => res.data);
}

export function cancelContainercall(
  containerId: string,
  reasonOfCancellation: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { containerId, reasonOfCancellation },
  };

  return axios
    .delete('/booking/bookings/cancelcontainer', config)
    .then(res => res.data);
}
export function addAccommodationToBookingContainer(accommodationOrderData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/booking/bookings/addaccommodationtobookingcontainer',
      accommodationOrderData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function makeAddOnBookingToContainer(accommodationOrderData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/booking/bookings/addaddonbookingtobookingcontainer',
      accommodationOrderData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function updateBookingContainer(accommodationOrderData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .post(
      '/booking/bookings/updatebookingcontainer',
      accommodationOrderData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function updateBookingNote(
  accommodationOrderData: UpdateBookingNoteItem,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .post('/booking/bookings/updatebookingnote', accommodationOrderData, config)
    .then(res => {
      return res.data;
    });
}

export function updateBookingToPleriminary(
  updateDataData: UpdateBookingToPreliminary,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/booking/bookings/updatebookingtopreliminary',
      updateDataData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function confirmBooking(accommodationOrderData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/booking/bookings/confirmbooking', accommodationOrderData, config)
    .then(res => {
      return res.data;
    });
}

export function addAAddOnToBookingContainer(addOnOrderData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/booking/bookings/addaddontobookingcontainer',
      addOnOrderData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function removeFromBookingContainer(removeData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/booking/bookings/removefrombookingcontainer', removeData, config)
    .then(res => {
      return res.data;
    });
}

export function detachFromBookingContainer(removeData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/booking/bookings/detachfrombookingcontainer', removeData, config)
    .then(res => {
      return res.data;
    });
}

export function clearContainer(removeData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/booking/bookings/clearbookingcontainer', removeData, config)
    .then(res => {
      return res.data;
    });
}

export function getbookingsbyaccommodation(bookingByAccommodationRequest) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/booking/bookings/getbookingsbyaccommodation',
      bookingByAccommodationRequest,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function setBookingErrorHandled(bookingId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { bookingId },
  };

  return axios
    .post('/booking/bookings/setbookingerrorhandled', {}, config)
    .then(res => {
      return res.data;
    });
}
